import { useLocalStorage } from '@mantine/hooks';
import { useCallback } from 'react';
import { Flags } from './FlagsHook';

export default function usePinnedFlags() {
  const [pinned, setPinned] = useLocalStorage<(keyof Flags)[]>({
    key: 'dev-pinned-flags',
    defaultValue: [],
  });

  const togglePin = useCallback(
    (key: keyof Flags) => {
      setPinned(prev => (prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]));
    },
    [setPinned],
  );

  const isPinned = useCallback((key: keyof Flags) => pinned.includes(key), [pinned]);

  return { pinned, togglePin, isPinned, hasPinned: pinned.length > 0 };
}
